// extracted by mini-css-extract-plugin
module.exports = {"designElementsParentContainer":"part-design-elements-container_designElementsParentContainer__mq_ZG","container":"part-design-elements-container_container__BgdjG"};